import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pt-4" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[25] || (_cache[25] = _createElementVNode("h3", null, "売上情報", -1)),
    _createVNode(_component_v_card, {
      color: "grey-lighten-5",
      class: "mt-2",
      variant: "flat"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _cache[2] || (_cache[2] = _createElementVNode("h5", null, "開始月", -1)),
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.searchFilter.monthFrom,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchFilter.monthFrom) = $event)),
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      type: "month"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _cache[3] || (_cache[3] = _createElementVNode("h5", null, "終了月", -1)),
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.searchFilter.monthTo,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchFilter.monthTo) = $event)),
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      clearable: "",
                      type: "month"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer)
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.listSales,
                      loading: _ctx.loading,
                      color: "primary",
                      variant: "flat",
                      block: ""
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode("検索", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_table, null, {
        default: _withCtx(() => [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _cache[5] || (_cache[5] = _createElementVNode("th", null, "項目名", -1)),
              _cache[6] || (_cache[6] = _createElementVNode("th", null, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sales, (item, i) => {
                return (_openBlock(), _createElementBlock("th", { key: i }, _toDisplayString(`${item.year}/${item.month}`), 1))
              }), 128))
            ])
          ]),
          (_ctx.sales)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_2, [
                _createElementVNode("tr", null, [
                  _cache[7] || (_cache[7] = _createElementVNode("td", null, "写真データ", -1)),
                  _cache[8] || (_cache[8] = _createElementVNode("td", null, "アップロード数", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sales, (item, i) => {
                    return (_openBlock(), _createElementBlock("td", { key: i }, _toDisplayString(item.sales.find(
                  (s) => s.mediaCategory == "photo" && s.mediaFormat == "data"
                ).unitOfUpload), 1))
                  }), 128))
                ]),
                _createElementVNode("tr", null, [
                  _cache[9] || (_cache[9] = _createElementVNode("td", null, null, -1)),
                  _cache[10] || (_cache[10] = _createElementVNode("td", null, "売上本数", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sales, (item, i) => {
                    return (_openBlock(), _createElementBlock("td", { key: i }, _toDisplayString(item.sales.find(
                  (s) => s.mediaCategory == "photo" && s.mediaFormat == "data"
                ).unitOfSales), 1))
                  }), 128))
                ]),
                _createElementVNode("tr", null, [
                  _cache[11] || (_cache[11] = _createElementVNode("td", null, null, -1)),
                  _cache[12] || (_cache[12] = _createElementVNode("td", null, "売上金額", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sales, (item, i) => {
                    return (_openBlock(), _createElementBlock("td", { key: i }, [
                      _createElementVNode("strong", null, _toDisplayString(item.sales.find(
                    (s) => s.mediaCategory == "photo" && s.mediaFormat == "data"
                  ).price + "円"), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("tr", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("td", null, "写真プリント", -1)),
                  _cache[14] || (_cache[14] = _createElementVNode("td", null, "アップロード数", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sales, (item, i) => {
                    return (_openBlock(), _createElementBlock("td", { key: i }, _toDisplayString(item.sales.find(
                  (s) => s.mediaCategory == "photo" && s.mediaFormat == "print"
                ).unitOfUpload), 1))
                  }), 128))
                ]),
                _createElementVNode("tr", null, [
                  _cache[15] || (_cache[15] = _createElementVNode("td", null, null, -1)),
                  _cache[16] || (_cache[16] = _createElementVNode("td", null, "売上本数", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sales, (item, i) => {
                    return (_openBlock(), _createElementBlock("td", { key: i }, _toDisplayString(item.sales.find(
                  (s) => s.mediaCategory == "photo" && s.mediaFormat == "print"
                ).unitOfSales), 1))
                  }), 128))
                ]),
                _createElementVNode("tr", null, [
                  _cache[17] || (_cache[17] = _createElementVNode("td", null, null, -1)),
                  _cache[18] || (_cache[18] = _createElementVNode("td", null, "売上金額", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sales, (item, i) => {
                    return (_openBlock(), _createElementBlock("td", { key: i }, [
                      _createElementVNode("strong", null, _toDisplayString(item.sales.find(
                    (s) =>
                      s.mediaCategory == "photo" && s.mediaFormat == "print"
                  ).price + "円"), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("tr", null, [
                  _cache[19] || (_cache[19] = _createElementVNode("td", null, "動画データ", -1)),
                  _cache[20] || (_cache[20] = _createElementVNode("td", null, "アップロード数", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sales, (item, i) => {
                    return (_openBlock(), _createElementBlock("td", { key: i }, _toDisplayString(item.sales.find(
                  (s) => s.mediaCategory == "movie" && s.mediaFormat == "data"
                ).unitOfUpload), 1))
                  }), 128))
                ]),
                _createElementVNode("tr", null, [
                  _cache[21] || (_cache[21] = _createElementVNode("td", null, null, -1)),
                  _cache[22] || (_cache[22] = _createElementVNode("td", null, "売上本数", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sales, (item, i) => {
                    return (_openBlock(), _createElementBlock("td", { key: i }, _toDisplayString(item.sales.find(
                  (s) => s.mediaCategory == "movie" && s.mediaFormat == "data"
                ).unitOfSales), 1))
                  }), 128))
                ]),
                _createElementVNode("tr", null, [
                  _cache[23] || (_cache[23] = _createElementVNode("td", null, null, -1)),
                  _cache[24] || (_cache[24] = _createElementVNode("td", null, "売上金額", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sales, (item, i) => {
                    return (_openBlock(), _createElementBlock("td", { key: i }, [
                      _createElementVNode("strong", null, _toDisplayString(item.sales.find(
                    (s) => s.mediaCategory == "movie" && s.mediaFormat == "data"
                  ).price + "円"), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}